import { client } from "../../../api/client";


export const createItemLookupTag = async (body) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.post(process.env.REACT_APP_GATEWAY_URI,'iquoteapi/itemlookuptag', body);
    } catch (error) {
        console.error("Error creating item lookup tag:", error);
        return [];
    }
  }
};

export const deleteItemLookupTags = async (itemLookupId) => {
  if (process.env.REACT_APP_USELOCALDATA === "false") {
    try {
        return await client.delete(process.env.REACT_APP_GATEWAY_URI,`iquoteapi/itemlookuptag/deletebyitemlookupid/${itemLookupId}`);
    } catch (error) {
        console.error("Error deleting item lookup tags:", error);
        return [];
    }
  }
};